import React, { Fragment, useCallback } from "react";
import { Pagination, PaginationItem, Stack, Typography } from "@mui/material";
import WestIcon from "@mui/icons-material/West";
import EastIcon from "@mui/icons-material/East";
import { useQueryParam } from "hooks";
import { useTranslation } from "react-i18next";
const PreviousUI = React.memo(() => {
  const { t } = useTranslation();
  return ((
  <Fragment>
    <WestIcon fontSize="small" />
    <Typography>{t("previous")}</Typography>
  </Fragment>
));
});

const NextUI = React.memo(() => {
  const { t } = useTranslation();
  return ((
  <Fragment>
    <Typography>{t("next")}</Typography>
    <EastIcon fontSize="small" />
  </Fragment>
));
});

const PaginationUI = ({ count }) => {
  const [page, setPage] = useQueryParam("page", 1);

  const handlePageChange = useCallback(
    (_, value) => {
      setPage(value);
    },
    [setPage]
  );

  return (
    <Stack
      sx={{
        justifyContent: "center",
        minHeight: 81,
        padding: 1,
        borderTop: "1px solid #DBDEE0"
      }}>
      <Pagination
        sx={(theme) => ({
          width: "100%",
          zIndex: 12,
          minWidth: "100%",
          minHeight: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& .MuiPagination-ul": {
            width: "100%",
            alignItems: "center",
            "& li": {
              "& .MuiPaginationItem-previousNext": {
                border: `1px solid ${theme.palette.common.border}`,
                borderRadius: `${theme.shape.borderRadius}px`,
                padding: "5px 15px",
                height: 36.5,
                gap: theme.spacing(1), 
                "& .MuiTypography-root": {
                  fontWeight: 600,
                },
              },
              "&:first-of-type": {
                flexGrow: 1,
              },
              "&:last-of-type": {
                flexGrow: 1,
                textAlign: "right",
              },
            },
          },
        })}
        onChange={handlePageChange}
        count={count}
        page={parseInt(page)}
        boundaryCount={3}
        renderItem={(item) => (
          <PaginationItem
            slots={{ previous: PreviousUI, next: NextUI }}
            {...item}
          />
        )}
      />
    </Stack>
  );
};

export default React.memo(PaginationUI);
